















export default {
	name: 'ProfileImage',

	computed: {
		userInitials() {
			return this.$auth.loggedIn
				? `${this.$auth.user.name[0]}${this.$auth.user.surname[0]}`
				: '';
		},
	},
};
